import axios from 'axios'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
  timeout: 60 * 1000, // 请求超时时间
  //   withCredentials: true,
})
// request拦截器  请求拦截
service.interceptors.request.use(
  config => {
    // const token = window.localStorage.getItem('token')
    // config.headers['Content-Type'] = 'application/json'
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`
    // }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器  响应拦截
service.interceptors.response.use(
  response => {
    if (response.data.data.errorcode == 401 && response.data.data.msg == "預約失效，請重新預約") {
      window.localStorage.removeItem('token')
    }
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)
export default service